module.exports = __webpack_public_path__ + "img/hik-robbi-cam.05dde474.png";